/**
 * Gets the domain from the url
 *
 * @param {string} url
 * @returns {string} domain
 */
export function getDomain(url) {
  const match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);

  if (!match) {
    return;
  }

  return match[2];
}

/**
 * Gets the headers for the domain (matching subdomain)
 *
 * @param {object} headers
 * @param {object} domain
 * @returns {object} headers for the domain
 */
export function getHeadersMatchingDomain(headers, targetDomain) {
  let headersForDomain = {};

  Object.entries(headers).forEach(([domain, domainHeaders]) => {
    if (targetDomain.match(new RegExp(`\\w*${domain}\\b`))) {
      headersForDomain = domainHeaders;
    }
  });

  return headersForDomain;
}
